import Vue from 'vue'
import router from './routes'
import * as Sentry from '@sentry/vue'
import { BrowserTracing } from '@sentry/tracing'

// import ServiceWorker from './registerServiceWorker'
import {
  LayoutPlugin,
  BCard,
  BFormInput,
  BFormTextarea,
  BFormCheckbox,
  BInputGroup,
  BInputGroupText,
  BContainer,
  BIcon,
  BRow,
  BAlert,
  BModal,
  BButton,
  BSpinner,
  BCollapse,
  BFormDatepicker,
  BInputGroupAppend,
  BSkeleton,
  BFormFile,
  BFormGroup,
  BFormRadio,
  BFormRadioGroup,
  BImgLazy,
} from 'bootstrap-vue'
import store from './store/index'
import ScreenSize from 'screen-size-vue'
import './utils/filters'
import VueClipboard from 'vue-clipboard2'
import VueCookies from 'vue-cookies'
import ReactGA4 from 'react-ga4'
// import '@emtrade/web-library'

// Vue.config.ignoredElements = ['my-hello', 'application-guide']

const App = () => import('@/layouts/App.vue')
VueClipboard.config.autoSetContainer = true
Vue.use(VueCookies)
Vue.use(VueClipboard)
Vue.use(ScreenSize)
// currency input
// Install BootstrapVue
Vue.use(LayoutPlugin)
Vue.component('b-card', BCard)
Vue.component('b-form-input', BFormInput)
Vue.component('b-form-textarea', BFormTextarea)
Vue.component('b-form-checkbox', BFormCheckbox)
Vue.component('b-input-group', BInputGroup)
Vue.component('b-input-group-text', BInputGroupText)
Vue.component('b-container', BContainer)
Vue.component('b-icon', BIcon)
Vue.component('b-row', BRow)
Vue.component('b-alert', BAlert)
Vue.component('b-modal', BModal)
Vue.component('b-button', BButton)
Vue.component('b-spinner', BSpinner)
Vue.component('b-collapse', BCollapse)
Vue.component('b-form-datepicker', BFormDatepicker)
Vue.component('b-input-group-append', BInputGroupAppend)
Vue.component('b-skeleton', BSkeleton)
Vue.component('b-form-file', BFormFile)
Vue.component('b-form-group', BFormGroup)
Vue.component('b-form-radio', BFormRadio)
Vue.component('b-form-radio-group', BFormRadioGroup)
Vue.component('b-img-lazy', BImgLazy)

Vue.config.productionTip = false

// if (process.env.VUE_APP_NODE_ENV === 'production') {
//   Sentry.init({
//     Vue,
//     environment: process.env.VUE_APP_NODE_ENV,
//     release: `${process.env.VUE_APP_NAME}@${process.env.VUE_APP_VERSION}`,
//     dsn: process.env.VUE_APP_SENTRY_DSN,
//     integrations: [
//       new BrowserTracing({
//         routingInstrumentation: Sentry.vueRouterInstrumentation(router),
//         tracingOrigins: [process.env.VUE_APP_API_URL, /^\//],
//       }),
//     ],
//     tracesSampleRate: 1.0,
//   })
// }

const measurmentId = process.env.VUE_APP_EVENT_MEASUREMENT_ID
if (measurmentId?.length) {
  ReactGA4.initialize([
    {
      trackingId: measurmentId,
    },
  ])
}

// ServiceWorker.register()

import './versioning'
import './assets/css/tailwind.css'

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app')
